import { PRESUPUESTADOR_SET_INTEGRATION_CLIENT } from '../constants'

export function reducer(state, action) {
    if (action.type === PRESUPUESTADOR_SET_INTEGRATION_CLIENT) {
        const {
            externalId = '',
            client = {},
            origin,
            target,
            platform
        } = action.data
        
        return {
            ...state,
            cliente: {
                id_cliente: '',
                ...client
            },
            external_id: externalId,
            origin,
            target,
            platform
        }
    } else {
        return state
    }
}
